import z from 'zod';

export const communicationMethodSchema = z.enum([
  'phone',
  'email',
  'social_media',
  'other',
]);

export type CommunicationMethod = z.infer<typeof communicationMethodSchema>;
